import axios from "axios"
import baseURL from "../config/api";

export const getFaqsForPublic = () => {
    return getFetchWithOutToken("faq/GetFaqs");
}

export const getFaqs = (token: string) => {
    return getFetch("faq", token);
}

export const getFaqsForAdmin = (token: string) => {
    return getFetch("faq/GetAdminFaq", token);
}

export const getFaqsForMember = (token: string) => {
    return getFetch("faq/GetMemberFaq", token);
}

export const getFaq = (primaryKey: string, token: string) => {
    return getFetch(`faq/${primaryKey}`, token)
}

export const postFaq = (data: any, token: string) => {
    return axios({
        url: `${baseURL}faq`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Faq = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}faq`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const put_Faq = (data: any, token: string) => {
    return axios({
        url: `${baseURL}faq`,
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}

const getFetchWithOutToken = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}